import { t } from 'i18next';
import { apiSlice } from 'src/app/redux/api/apiSlice';
import { finalUrlsConfig } from 'src/configs/url.config';

export const blackSystemSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    start: builder.mutation<any, any>({
      query: ({ data, url }) => ({
        url: finalUrlsConfig().blackSystem(url).start,
        method: 'POST',
        body: data,
      }),
    }),
    exportData: builder.mutation<any, any>({
      query: ({ data, url }) => ({
        url: finalUrlsConfig().blackSystem(url).export,
        method: 'POST',
        body: data,
        responseHandler: async (response: any) => {
          if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse?.message || t('errors.defaultErrorText'));
          }
          return response.blob();
        },
        cache: 'no-cache',
      }),
    }),
    number: builder.mutation<any, any>({
      query: ({ data, url }) => ({
        url: finalUrlsConfig().blackSystem(url).number,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useStartMutation, useExportDataMutation, useNumberMutation } = blackSystemSlice;
